import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CreateDatabaseMutation: GraphQLTaggedNode = graphql`
	mutation CreateDatabaseMutation($spaceKey: String!, $parentId: ID) {
		createContentContextual(
			input: { parentId: $parentId, spaceKey: $spaceKey, status: CURRENT, type: "database" }
		) {
			id
			space {
				id
				key
				alias
			}
		}
	}
`;
